import React from 'react'
import { Block } from '@/components/crRender'
import Skeleton from '@/components/skeletonBase'
import { Icon } from '@iconify/react'
import InputFieldSkeleton from '@/components/formFields/InputField/InputFieldSkeleton'
import DropDownSkeleton from '@/components/formFields/DropDown/DropDownSkeleton'
import '../create/style.css'

const EditedInfoSkeleton = ({ isLoading }) => {

    return (
        <Block isRender={isLoading} className="create-doctor-container">
            {/* Header Skeleton */}
            <div className="page-header">
                <Skeleton variant="text" width="150px" height="20px" style={{ marginBottom: '16px' }} />
                <Skeleton variant="text" width="250px" height="32px" style={{ marginBottom: '8px' }} />
                <Skeleton variant="text" width="200px" height="14px" />
            </div>

            {/* Personal & Contact Information Section Skeleton */}
            <div className="form-section">
                <div className="section-header">
                    <Icon icon="mdi:account-circle" className="section-icon" style={{ color: '#e5e7eb' }} />
                    <Skeleton variant="text" width="300px" height="18px" />
                </div>

                <div className="section-content">
                    {/* Profile Image Upload Skeleton */}
                    <div className="form-group full-width">
                        <Skeleton variant="text" width="150px" height="14px" style={{ marginBottom: '8px' }} />
                        <Skeleton variant="rectangular" width="100%" height="150px" style={{ borderRadius: '8px' }} />
                    </div>

                    {/* Form Fields Row 1 */}
                    <div className="row">
                        <InputFieldSkeleton isRender={true} className="col-md-6" />
                        <InputFieldSkeleton isRender={true} className="col-md-6" />
                    </div>

                    {/* Form Fields Row 2 */}
                    <div className="row">
                        <InputFieldSkeleton isRender={true} className="col-md-6" />
                        <InputFieldSkeleton isRender={true} className="col-md-6" />
                    </div>

                    {/* Date Picker Skeleton */}
                    <div className="row">
                        <InputFieldSkeleton isRender={true} className="col-md-6" />
                    </div>

                    {/* Bio TextArea Skeleton */}
                    <div className="row">
                        <div className="col-md-12">
                            <Skeleton variant="text" width="120px" height="14px" style={{ marginBottom: '8px' }} />
                            <Skeleton variant="rectangular" width="100%" height="120px" style={{ marginBottom: '20px', borderRadius: '8px' }} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Specialization & Documents Section Skeleton */}
            <div className="form-section">
                <div className="section-header">
                    <Icon icon="mdi:certificate" className="section-icon" style={{ color: '#e5e7eb' }} />
                    <Skeleton variant="text" width="250px" height="18px" />
                </div>

                <div className="section-content">
                    {/* Dropdown Fields */}
                    <DropDownSkeleton isRender={true} />
                    <DropDownSkeleton isRender={true} />

                    {/* Documents Upload Skeleton */}
                    <div className="form-group full-width">
                        <Skeleton variant="text" width="200px" height="14px" style={{ marginBottom: '8px' }} />
                        <Skeleton variant="rectangular" width="100%" height="150px" style={{ borderRadius: '8px' }} />
                    </div>
                </div>
            </div>

            {/* Action Buttons Skeleton */}
            <div className="form-actions">
                <Skeleton variant="rectangular" width="100px" height="40px" style={{ borderRadius: '8px' }} />
                <Skeleton variant="rectangular" width="120px" height="40px" style={{ borderRadius: '8px' }} />
            </div>
        </Block>
    )
}

export default EditedInfoSkeleton